import noUiSlider from "./nouislider.min.mjs";

class PriceSlider extends HTMLElement {
  constructor() {
    super();
    this.init();
  }

  init() {
    const priceSlider = this.querySelector(".f-price__slider");
    const inputFrom = this.querySelector(".f-price__input--from");
    const inputTo = this.querySelector(".f-price__input--to");
    const rangeMin = parseInt(priceSlider.dataset.min);
    const rangeMax = parseInt(priceSlider.dataset.max);
    const step = parseInt(priceSlider.dataset.step);
    const currency = priceSlider.dataset.currency;
    const applyButton = document.querySelector(".wt-filter__footer .wt-cart__cta");
    const facetForm = document.querySelector("facet-filters-form > form");
    const isSliderInCollapsible = this.closest(".f-price-slider ");
    const isRtl = document.documentElement.getAttribute("dir") === "rtl";

    noUiSlider.create(priceSlider, {
      start: [inputFrom.value || 0, inputTo.value || 0],
      connect: true,
      step,
      tooltips: [true, true],
      range: {
        min: rangeMin,
        max: rangeMax,
      },
      direction: isRtl ? "rtl" : "ltr",
      format: wNumb({
        decimals: 0,
        thousand: "",
        prefix: "",
      }),
    });

    if (isSliderInCollapsible) {
      const uiHandlers = priceSlider.querySelectorAll(".noUi-handle");
      setTabindex(uiHandlers, "-1");
    }

    // noUiSlider is created while its container may still be hidden
    // (closed accordion and/or closed mobile filter drawer). In that case
    // it renders with a broken/invisible layout since it has no width to
    // measure against. Force a clean re-layout every time the accordion or
    // the drawer toggles open, so the slider always displays correctly.
    //
    // On iOS Safari specifically, the filter drawer is a `position: fixed`
    // element animated with `transform`, and WebKit can fail to repaint its
    // content (stale compositing layer) until an unrelated interaction
    // forces a repaint. Forcing a synchronous reflow (reading offsetHeight)
    // in addition to updateOptions() nudges WebKit into repainting
    // immediately instead of leaving the slider stuck invisible.
    const refreshSlider = () => {
      if (priceSlider.noUiSlider) {
        priceSlider.noUiSlider.updateOptions({}, false);
      }
      // eslint-disable-next-line no-unused-expressions
      priceSlider.offsetHeight;
    };

    const collapsibleEl = this.closest("collapsible-section");
    if (collapsibleEl) {
      const collapsibleObserver = new MutationObserver(refreshSlider);
      collapsibleObserver.observe(collapsibleEl, {
        attributes: true,
        attributeFilter: ["data-open"],
      });
    }

    const drawerEl = this.closest(".wt-filter");
    if (drawerEl) {
      const drawerObserver = new MutationObserver(refreshSlider);
      drawerObserver.observe(drawerEl, {
        attributes: true,
        attributeFilter: ["class"],
      });
      // Also refresh once the slide-in transition has actually finished,
      // in case WebKit only repaints the stale layer at that point.
      drawerEl.addEventListener("transitionend", refreshSlider);
    }

    window.addEventListener("resize", refreshSlider);

    const debouncedUpdate = debounce((values, handle) => {
      let value = values[handle];
      if (handle) {
        inputTo.value = value;
        inputTo.setAttribute("value", value);
        inputTo.dispatchEvent(new Event("change"));
      } else {
        inputFrom.value = value;
        inputFrom.setAttribute("value", value);
        inputFrom.dispatchEvent(new Event("change"));
      }

      facetForm.dispatchEvent(new Event("input"));
    }, 300);

    priceSlider.noUiSlider.on("change", function (values, handle) {
      debouncedUpdate(values, handle);
    });

    inputFrom.addEventListener("change", function () {
      priceSlider.noUiSlider.set([this.value, null]);
    });

    inputTo.addEventListener("change", function () {
      priceSlider.noUiSlider.set([null, this.value]);
    });

    applyButton.addEventListener("click", () => {
      inputTo.dispatchEvent(new Event("change"));
      inputFrom.dispatchEvent(new Event("change"));
    });
  }

  debounce(func, wait) {
    let timeout;
    return function (...args) {
      const context = this;
      clearTimeout(timeout);
      timeout = setTimeout(() => func.apply(context, args), wait);
    };
  }
}

customElements.define("price-slider", PriceSlider);
